import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

const TextBlock = styled.div`
  margin: 0;
  padding: 0.25rem;
`

const InfoBlock = ({ infotext }) => (
      <TextBlock>
        {infotext}
      </TextBlock>
)

InfoBlock.propTypes = {
  infotext: PropTypes.string,
}

InfoBlock.defaultProps = {
  infotext: ``,
}

export default InfoBlock